import { useQuery } from "@tanstack/react-query";
import { Radio } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getInsightsHeadline } from "../actions/acc_actions";
import Loading from "../utils/Loading";

export default function InsightsSummary({ selectedSchema }) {
  const { t } = useTranslation();
  const [value, setValue] = useState("day");
  const businessSlug = useSelector((state) => state.account.businessSlug);

  const options = [
    { label: t("day"), value: "day" },
    { label: t("week"), value: "week" },
    { label: t("month"), value: "month" },
    { label: t("year"), value: "year" },
    { label: t("all"), value: "all" },
  ];

  const {
    isLoading,
    data: insightsData,
    isFetching,
  } = useQuery({
    queryKey: ["insightsHeadline", businessSlug, value, selectedSchema],
    queryFn: () =>
      getInsightsHeadline({
        refresh: false,
        period: value,
        loyalty_scheme_slug: selectedSchema,
      }),
    enabled: !!value && !!businessSlug && !!selectedSchema,
  });

  const data = insightsData?.body?.data;

  if (!data || isLoading) return <Loading />;

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const cards = [
    {
      title: t("total_customers"),
      data: data.total_customers,
      imgClass: "img-mov",
      imgSrc: "/assets/images/icons/insights/group.png",
    },
    {
      title: t("total_stamps"),
      data: data.total_stamps,
      imgClass: "img-pink",
      imgSrc: "/assets/images/icons/insights/path.png",
    },
    {
      title: t("total_rewards"),
      data: data.total_vouchers_awarded,
      imgClass: "img-orange",
      imgSrc: "/assets/images/icons/insights/reward.png",
    },
    {
      title: t("total_visits"),
      data: data.total_visits,
      imgClass: "img-yellow",
      imgSrc: "/assets/images/icons/insights/loc.png",
    },
  ];

  return (
    <div className="insights_summary-container">
      <div className="insights_summary">
        <div className="radio-container">
          <h4>{t("headline_stats_for")}</h4>
          <Radio.Group
            onChange={onChange}
            value={value}
            options={options}
            optionType="button"
            buttonStyle="solid"
          />
        </div>
        <div className="insights_summary-cards">
          {isFetching || isLoading || !data ? (
            <Loading />
          ) : (
            cards.map((card, index) => (
              <div className="insights_summary-card" key={index}>
                <div className="insights_summary-card-header">
                  <div>
                    <h5>{card.title}</h5>
                    <h3>{formatNumber(Number(card.data.value))}</h3>
                  </div>
                  <div className={`img-container ${card.imgClass}`}>
                    <img src={card.imgSrc} alt={card.title} />
                  </div>
                </div>
                <div>
                  <h6>
                    <img
                      src="/assets/images/icons/insights/arrow.png"
                      alt={t("trend")}
                    />
                    <span
                      className={
                        card.data.percentage_change >= 0 ? "active" : "negative"
                      }
                    >
                      {typeof card.data.percentage_change === "number"
                        ? ` ${Number(card.data.percentage_change).toFixed(2)}%`
                        : t("n_a")}
                    </span>{" "}
                    {card.data.percentage_change >= 0 ? t("up") : t("down")}{" "}
                    {t("from_previous_period")}
                  </h6>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
